<template>
	<li
		class="flex items-center px-4 py-2 border rounded-sm bg-white hover:bg-[var(--background-primary-hover)] justify-between"
	>
		<slot />
	</li>
</template>
